import React from 'react'
import styles from './loading.module.sass'

// Under the page's root class, like LoadError, so the white-label styles can't
// repaint it. It sits where LoadError would, so a failed load doesn't jump.
export const Loading = () => (
  <p className={`ffpDashboard ${styles.loading}`} role="status">
    Loading the dashboard…
  </p>
)
